import { render, staticRenderFns } from "./supplier-tier-line.vue?vue&type=template&id=f3521700&scoped=true"
import script from "./supplier-tier-line.vue?vue&type=script&lang=js"
export * from "./supplier-tier-line.vue?vue&type=script&lang=js"
import style0 from "./supplier-tier-line.vue?vue&type=style&index=0&id=f3521700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3521700",
  null
  
)

export default component.exports